<template>
  <div class="">
    <hr/>
    <div class="col-md-13 p-0 mt-2">
      <div class="material-count">
        {{ materialCount }}
        <template v-if="materialCount > 1"> materialen</template>
        <template v-else> materiaal</template>

        <span class="float-right">
          <template v-if="!calculatingStatus">
            <span @click="calculate" class="calculate-link btn btn-small btn-outline-oldevuuren btn-round" :class="{'disabled': calculatingStatus !== null}">
              <font-awesome-icon class="font-awesome-icon" icon="calculator"/> Berekenen
            </span>
          </template>
        </span>
      </div>
    </div>

    <div v-if="showPrices" class="card card-body">
      <div class="row">
        <div class="col-md-13">
          <template v-if="calculatingStatus">
            <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
          </template>
          <template v-else>
            <div class="material-price grayed-price" :class="{'muted-price': calculatingStatus === null}">
              Prijs panelen
              <div class="price-value">
                {{ priceDetails.material_price | price }}
              </div>
            </div>
            <div class="transport-price grayed-price" :class="{'muted-price': calculatingStatus === null}">
              Transportkosten
              <div class="price-value">
                {{ priceDetails.transport_price | price }}
              </div>
            </div>
            <div class="total-price mt-1" :class="{'muted-price': calculatingStatus === null}">
              Totaalprijs (ex. BTW)
              <div class="price-value">
                {{ priceDetails.total_price | price }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="col-md-13 p-0 mt-3" ref="orderButtonTooltip">
      <button
        @click="order"
        class="btn btn-oldevuuren w-100 btn-round"
        :disabled="calculatingStatus === null">
        Naar bestellen
        <font-awesome-icon class="font-awesome-icon" v-if="savingOrderRedirect" icon="spinner" spin/>
      </button>
      <b-tooltip v-if="showOrderTooltip" :target="() => $refs['orderButtonTooltip']" variant="secondary" placement="bottom">
        <template v-if="showPrices === false">Maak eerst een berekening</template>
        <template v-else-if="calculatingStatus === true">Berekening wordt gemaakt...</template>
        <template v-else>Maak eerst een nieuwe berekening</template>
      </b-tooltip>
    </div>

    <div class="col-md-13 p-0 mt-3 mb-3 save-order text-center">
      <div v-if="savingOrder === false">
        <font-awesome-icon class="font-awesome-icon" icon="check"/>
        Offerte opgeslagen in
        <span @click="gotoDashboard" class="router-link">dashboard</span>
      </div>
      <div v-else>
        <button
          @click="save"
          class="btn btn-outline-oldevuuren w-100 btn-round">
          <font-awesome-icon class="font-awesome-icon" icon="save"/>
          Offerte opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="savingOrder" icon="spinner" spin/>
        </button>
      </div>
    </div>

    <template v-if="!isAuthenticated">
      <!-- Load the login form -->
      <app-login ref="appLogin" v-bind:registerParent="register" v-bind:forgotPasswordParent="forgotPassword"/>
      <app-register ref="appRegister" v-bind:loginParent="login" v-bind:forgotPasswordParent="forgotPassword"/>
      <app-forgot-password ref="appForgotPassword" v-bind:registerParent="register"/>
    </template>

    <b-modal
      ref="placing-order-modal"
      id="placing-order-modal"
      centered
      hide-footer
      :visible="validatingOrderError !== false"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Let op</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="" v-html="validatingOrderError">
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Login from '@/components/Auth/Login.vue'
  import Register from '@/components/Auth/Register.vue'
  import ForgotPassword from '@/components/Auth/ForgotPassword.vue'

  import { CALCULATE_ORDER, MUTATE_SAVING_ORDER, MUTATE_VALIDATING_ORDER_ERROR, SAVE_ORDER, SAVE_ORDER_REDIRECT, RESET_CART } from '../../../store/types'
  import { orderValidation } from '../../../mixins/order-validation'

  export default {
    data() {
      return {
        showPrices: false
      }
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.isAuthenticated
      },
      materialCount() {
        return !this.$store.getters.cartMaterials ? null : this.$store.getters.cartMaterials.length
      },
      validatingOrderError() {
        return this.$store.getters.validatingOrderError
      },
      savingOrder() {
        return this.$store.getters.savingOrder
      },
      savingOrderRedirect() {
        return this.$store.getters.savingOrderRedirect
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      },
      showOrderTooltip() {
        return this.$store.getters.totalPanelCount === 0 || this.calculatingStatus !== false
      },
      calculatingStatus() {
        return this.$store.getters.calculatingStatus
      },
      priceDetails() {
        return this.$store.getters.priceDetails
      }
    },
    watch: {
      cart: {
        handler() {
          // Reset calculating status
          this.$store.commit(MUTATE_SAVING_ORDER, null)
        },
        deep: true
      }
    },
    methods: {
      login() {
        this.$refs.appLogin.showModal()
      },
      register() {
        this.$refs.appRegister.showModal()
      },
      forgotPassword() {
        this.$refs.appForgotPassword.showModal()
      },
      calculate() {
        if (this.isAuthenticated) {
          if (this.validateOrder(this.cart)) {
            this.$store.dispatch(CALCULATE_ORDER, this.cart)
            this.showPrices = true
          }
        } else {
          this.login()
        }
      },
      save() {
        if (this.isAuthenticated) {
          this.$store.dispatch(SAVE_ORDER, this.cart)
        } else {
          this.login()
        }
      },
      order() {
        if (this.isAuthenticated) {
          if (this.validateOrder(this.cart)) {
            this.$store.dispatch(SAVE_ORDER_REDIRECT, this.cart)
          }
        } else {
          this.login()
        }
      },
      gotoDashboard() {
        // Empty cart & return to the dashboard
        this.$store.dispatch(RESET_CART)
        this.$router.push({ path: 'dashboard' })
      },
      hideModal() {
        this.$refs['placing-order-modal'].hide()
      }
    },
    mixins: [orderValidation],
    created() {
      if (this.priceDetails) {
        // It looks like we already made a calculation (comming back from the order page?), so show the prices
        this.showPrices = true
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        // Remove the validation error
        this.$store.commit(MUTATE_VALIDATING_ORDER_ERROR, false)
      })
    },
    components: {
      'app-login': Login,
      'app-register': Register,
      'app-forgot-password': ForgotPassword
    }
  }
</script>

<style lang="scss" scoped>
  .muted-price {
    color: $light-grey !important;
  }

  .material-count {
    font-weight: bold;
    color: $light-grey;
    margin-bottom: 15px;

    .transport-price {
      color: $dark-grey;
      font-size: 0.9em;
    }
  }

  .calculate-link {
    font-weight: bold;
    cursor: pointer;

    &.disabled {
        color: $light-grey;
        border-color: $light-grey;
    }
  }

  .btn-small {
    padding: 3px 10px !important;
    font-size: 0.9em;
  }

  .save-order {
    font-size: 0.9em;
  }

  .router-link {
    text-decoration: underline;
    color: $oldevuuren-blue;
    cursor: pointer;
  }

  .router-link:hover {
    color: $oldevuuren-darkblue;
  }

</style>
